import React, { useState } from 'react'
import { Col, Container, Form, FormGroup } from 'reactstrap';
import CustomInput from './CustomInput';
import { Eye, EyeOff } from 'assets';
import CustomButton from 'components/CustomButton';
import { useNavigate } from 'react-router-dom';

const BuatPassword = () => {
  const [isPasswordShow, setIsPasswordShow] = useState({
    password: false,
    repeatPassword: false
  })
  const [passwordForm, setPasswordForm] = useState({
    password: "",
    repeatPassword: ""
  })
  const [inputError, setInputError] = useState({
    password: "",
    repeatPassword: ""
  })

  const navigate = useNavigate()
  const errorMessage = {
    password: "Kata sandi terlalu pendek, minimal 8 karakter",
    repeatPassword: "Kata sandi tidak sama"
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    navigate("/auth/login")
  }

  const passwordIconAction = (name) => {
    setIsPasswordShow({ ...isPasswordShow, [name]: !isPasswordShow[name] })
  }


  const onChange = (e) => {
    const { name, value } = e.target
    let isValid;

    switch (name) {
      case "password":
        isValid = value.length < 8 ? false : true
        break
      case "repeatPassword":
        isValid = passwordForm.password === value || value === ""
        break
    }

    setPasswordForm({ ...passwordForm, [name]: value })
    if (!isValid) return setInputError({ ...inputError, [name]: errorMessage[name] })
    if (isValid) return setInputError({ ...inputError, [name]: "" })
  }

  return (
    <Container>
      <div className='text-wrapper'>
        <h3>Buat Password Baru</h3>
        <h6>Masukkan password baru anda.</h6>
      </div>
      <Col>
        <Form className='auth-form' onSubmit={handleSubmit}>
          <FormGroup className='custom-form-group'>
            <CustomInput
              label="Password"
              name="password"
              placeholder="Password"
              onChange={onChange}
              value={passwordForm.password}
              type={`${isPasswordShow.password ? "text" : "password"}`}
              Icon={isPasswordShow.password ? Eye : EyeOff}
              iconPosition="right"
              iconAction={() => passwordIconAction("password")}
              error={inputError.password}
            />
          </FormGroup>
          <FormGroup className='custom-form-group'>
            <CustomInput
              label="Ulangi Password"
              name="repeatPassword"
              placeholder="Password"
              onChange={onChange}
              value={passwordForm.repeatPassword}
              type={`${isPasswordShow.repeatPassword ? "text" : "password"}`}
              Icon={isPasswordShow.repeatPassword ? Eye : EyeOff}
              iconPosition="right"
              iconAction={() => passwordIconAction("repeatPassword")}
              error={inputError.repeatPassword}
            />
          </FormGroup>
          <CustomButton
            label="Ubah Password"
            color="primary-btn"
          />
        </Form>
      </Col>
    </Container>
  )
}

export default BuatPassword